import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'footnav',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/footnav')), 'footnav'),
      children: [
        {
          path: '/',
          name: 'workbench',
          component: resolve => require.ensure([], () => resolve(require('@/public/home/workbench')), 'workbench')
        },
        {
          path: 'workbench',
          name: 'workbench',
          component: resolve => require.ensure([], () => resolve(require('@/public/home/workbench')), 'workbench')
        },
        {
          path: '/mine',
          name: 'mine',
          component: resolve => require.ensure([], () => resolve(require('@/public/home/mine')), 'mine')
        },
        {
          path: '/footnav',
          name: 'footnav',
          component: resolve => require.ensure([], () => resolve(require('@/public/home/footnav')), 'footnav')
        }
      ]
    },
    {
      path: '/setReviewer',
      name: 'setReviewer',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/dailyRecord/setReviewer')), 'setReviewer')
    },
    {
      path: '/dailyRecord',
      name: 'dailyRecord',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/dailyRecord/dailyRecord')), 'dailyRecord')
    },
    {
      path: '/logComments',
      name: 'logComments',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/dailyRecord/logComments')), 'logComments')
    },
    {
      path: '/dailyRecordAdd',
      name: 'dailyRecordAdd',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/dailyRecord/dailyRecordAdd')), 'dailyRecordAdd')
    },
    {
      path: '/selectSpaceTime',
      name: 'selectSpaceTime',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/dailyRecord/selectSpaceTime')), 'selectSpaceTime')
    },
    {
      path: '/myDailyRecord',
      name: 'myDailyRecord',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/dailyRecord/myDailyRecord')), 'myDailyRecord')
    },
    {
      path: '/dailyRecordView',
      name: 'dailyRecordView',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/dailyRecord/dailyRecordView')), 'dailyRecordView')
    },
    {
      path: '/userInfo',
      name: 'userInfo',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/userInfo')), 'userInfo')
    },
    {
      path: '/feedback',
      name: 'feedback',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/feedback')), 'feedback')
    },
    {
      path: '/valueCaseStudy',
      name: 'valueCaseStudy',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/valueCaseStudy')), 'valueCaseStudy')
    },
     {
      path: '/scoreRulePage',
      name: 'scoreRulePage',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/scoreRulePage')), 'scoreRulePage')
    },
    {
      path: '/resourceList',
      name: 'resourceList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/resource/resourceList')), 'resourceList')
    },
    {
      path: '/resDetail',
      name: 'resDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/resource/resDetail')), 'resDetail')
    },
    {
      path: '/resLook',
      name: 'resLook',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/resource/resLook')), 'resLook')
    },
    {
      path: '/resAdd',
      name: 'resAdd',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/resource/resAdd')), 'resAdd')
    },
    {
      path: '/resRelevanceProject',
      name: 'resRelevanceProject',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/resource/resRelevanceProject')), 'resRelevanceProject')
    },
    {
      path: '/resEditDetail',
      name: 'resEditDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/resource/resEditDetail')), 'resEditDetail')
    },
    {
      path: '/resFollowUp',
      name: 'resFollowUp',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/resource/follow/resFollowUp')), 'resFollowUp')
    },
    {
      path: '/resFollowUpList',
      name: 'resFollowUpList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/resource/follow/resFollowUpList')), 'resFollowUpList')
    },
    {
      path: '/resFollowUpDetail',
      name: 'resFollowUpDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/resource/follow/resFollowUpDetail')), 'resFollowUpDetail')
    },
    {
      path: '/resFollowUpRecords',
      name: 'resFollowUpRecords',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/resource/follow/resFollowUpRecords')), 'resFollowUpRecords')
    },
    {
      path: '/resWaitFollowUpList',
      name: 'resWaitFollowUpList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/resource/wait/resWaitFollowUpList')), 'resWaitFollowUpList')
    },
    {
      path: '/sendGift',
      name: 'sendGift',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/gift/sendGift')), 'sendGift')
    },
    {
      path: '/sendGiftRecord',
      name: 'sendGiftRecord',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/gift/sendGiftRecord')), 'sendGiftRecord')
    },
    {
      path: '/selectGift',
      name: 'selectGift',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/gift/selectGift')), 'selectGift')
    },
    {
      path: '/giftStandard',
      name: 'giftStandard',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/gift/giftStandard')), 'giftStandard')
    },
    {
      path: '/agreementProjectList',
      name: 'agreementProjectList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/FollowUp/agreement/agreementProjectList')), 'agreementProjectList')
    },
    {
      path: '/agreementProjectListDetails',
      name: 'agreementProjectListDetails',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/FollowUp/agreement/agreementProjectListDetails')), 'agreementProjectListDetails')
    },
    {
      path: '/projectFollowUpList',
      name: 'projectFollowUpList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/FollowUp/project/projectFollowUpList')), 'projectFollowUpList')
    },
    {
      path: '/resourceFollowUpList',
      name: 'resourceFollowUpList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/FollowUp/resource/resourceFollowUpList')), 'resourceFollowUpList')
    },
    {
      path: '/clauseFollowUpList',
      name: 'clauseFollowUpList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/FollowUp/clause/clauseFollowUpList')), 'clauseFollowUpList')
    },
    {
      path: '/agreementFollowUpList',
      name: 'agreementFollowUpList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/FollowUp/agreement/agreementFollowUpList')), 'agreementFollowUpList')
    },
    {
      path: '/projectList',
      name: 'projectList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/projectList')), 'projectList')
    },
    {
      path: '/selectProjectManager',
      name: 'selectProjectManager',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/selectProjectManager')), 'selectProjectManager')
    },
    {
      path: '/editProjectDetail',
      name: 'editProjectDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/editProjectDetail')), 'editProjectDetail')
    },
    {
      path: '/developerList',
      name: 'developerList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/developerList')), 'developerList')
    },
    {
      path: '/addDeveloper',
      name: 'addDeveloper',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/addDeveloper')), 'addDeveloper')
    },
    {
      path: '/projectDetail',
      name: 'projectDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/projectDetail')), 'projectDetail')
    },
    {
      path: '/parkPicture',
      name: 'parkPicture',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/parkPicture')), 'parkPicture')
    },
    {
      path: '/addPicture',
      name: 'addPicture',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/addPicture')), 'addPicture')
    },
    {
      path: '/updatePassword',
      name: 'updatePassword',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/updatePassword')), 'updatePassword')
    },
    {
      path: '/projectUpdate',
      name: 'projectUpdate',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/projectUpdate')), 'projectUpdate')
    },
    {
      path: '/propertyList',
      name: 'propertyList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/propertyList')), 'propertyList')
    },
    {
      path: '/addProperty',
      name: 'addProperty',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/addProperty')), 'addProperty')
    },
    {
      path: '/projectFollowUpCommonList',
      name: 'projectFollowUpCommonList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/follow/projectFollowUpCommonList')), 'projectFollowUpCommonList')
    },
    {
      path: '/projectFollowUpDetail',
      name: 'projectFollowUpDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/follow/projectFollowUpDetail')), 'projectFollowUpDetail')
    },
    {
      path: '/projectFollowUp',
      name: 'projectFollowUp',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/follow/projectFollowUp')), 'projectFollowUp')
    },
    {
      path: '/projectFollowRecords',
      name: 'projectFollowRecords',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/follow/projectFollowRecords')), 'projectFollowRecords')
    },
    {
      path: '/uploadCommerceClause',
      name: 'uploadCommerceClause',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/uploadCommerceClause')), 'uploadCommerceClause')
    },
    {
      path: '/statisticsDetail',
      name: 'statisticsDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/statistics/statisticsDetail')), 'statisticsDetail')
    },
    {
      path: '/promotionScoreDetail',
      name: 'promotionScoreDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/statistics/promotionScoreDetail')), 'promotionScoreDetail')
    },
    {
      path: '/auditRecord',
      name: 'auditRecord',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/auditRecord')), 'auditRecord')
    },
    {
      path: '/auditClauseFollowUp',
      name: 'auditClauseFollowUp',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/FollowUp/clause/auditClauseFollowUp')), 'auditClauseFollowUp')
    },
    {
      path: '/auditAgreementFollowUp',
      name: 'auditAgreementFollowUp',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/FollowUp/agreement/auditAgreementFollowUp')), 'auditAgreementFollowUp')
    },
    {
      path: '/projectInventory',
      name: 'projectInventory',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/projectInventory')), 'projectInventory')
    },
    {
      path: '/projectLost',
      name: 'projectLost',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/inventory/projectLost')), 'projectLost')
    },
    {
      path: '/itemConfirmation',
      name: 'itemConfirmation',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/inventory/itemConfirmation')), 'itemConfirmation')
    },
    {
      path: '/fileboard',
      name: 'fileboard',
      component: resolve => require.ensure([], () => resolve(require('@/components/fileboard')), 'fileboard')
    },
    {
      path: '/waitReceive',
      name: 'waitReceive',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/waiting/waitReceive')), 'waitReceive')
    },
    {
      path: '/addTag',
      name: 'addTag',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/tag/addTag')), 'addTag')
    },
    {
      path: '/msgBoard',
      name: 'msgBoard',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/msg/msgBoard')), 'msgBoard')
    },
    {
      path: '/msgList',
      name: 'msgList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/msg/msgList')), 'msgList')
    },
    {
      path: '/msgNotice',
      name: 'msgNotice',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/msg/msgNotice')), 'msgNotice')
    },
    {
      path: '/msgListDetail',
      name: 'msgListDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/msg/msgListDetail')), 'msgListDetail')
    },
    {
      path: '/noticeList',
      name: 'noticeList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/msg/noticeList')), 'noticeList')
    },
    {
      path: '/feedbackList',
      name: 'feedbackList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/feedbackList')), 'feedbackList')
    },
    {
      path: '/feedbackDetail',
      name: 'feedbackDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/feedbackDetail')), 'feedbackDetail')
    },
    {
      path: '/integralDetail',
      name: 'integralDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/integralDetail')), 'integralDetail')
    },
    {
      path: '/relationResourceList',
      name: 'relationResourceList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/relationResourceList')), 'relationResourceList')
    },
    {
      path: '/recordingList',
      name: 'recordingList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/record/recordingList')), 'recordingList')
    },
    {
      path: '/mailList',
      name: 'mailList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/roster/mailList')), 'mailList')
    },
    {
      path: '/employeeDetail',
      name: 'employeeDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/roster/employeeDetail')), 'employeeDetail')
    },
    {
      path: '/historicalProject',
      name: 'historicalProject',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/roster/historicalProject')), 'historicalProject')
    },
    {
      path: '/transferRecord',
      name: 'transferRecord',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/roster/transferRecord')), 'transferRecord')
    },
    {
      path: '/borrowingRecords',
      name: 'borrowingRecords',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/borrow/borrowingRecords')), 'borrowingRecords')
    },
    {
      path: '/contractBorrowing',
      name: 'contractBorrowing',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/borrow/contractBorrowing')), 'contractBorrowing')
    },
    {
      path: '/articleBorrowing',
      name: 'articleBorrowing',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/borrow/articleBorrowing')), 'articleBorrowing')
    },
    {
      path: '/addBorrowing',
      name: 'addBorrowing',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/borrow/addBorrowing')), 'addBorrowing')
    },
    {
      path: '/receiptBorrowing',
      name: 'receiptBorrowing',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/borrow/receiptBorrowing')), 'receiptBorrowing')
    },
    {
      path: '/officialSealBorrowing',
      name: 'officialSealBorrowing',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/borrow/officialSealBorrowing')), 'officialSealBorrowing')
    },
    {
      path: '/scoreType',
      name: 'scoreType',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/score/scoreType')), 'scoreType')
    },
    {
      path: '/score',
      name: 'score',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/score/score')), 'score')
    },
    {
      path: '/allPersonList',
      name: 'allPersonList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/score/allPersonList')), 'allPersonList')
    },
    {
      path: '/recordScoreList',
      name: 'recordScoreList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/score/recordScoreList')), 'recordScoreList')
    },
    {
      path: '/scoreView',
      name: 'scoreView',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/score/scoreView')), 'scoreView')
    },
    {
      path: '/summaryTable',
      name: 'summaryTable',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/summaryTable')), 'summaryTable')
    }, {
      path: '/summaryTable2',
      name: 'summaryTable2',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/summaryTable2')), 'summaryTable2')
    },
    {
      path: '/summaryTable3',
      name: 'summaryTable3',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/summaryTable3')), 'summaryTable3')
    },
    {
      path: '/summaryTable4',
      name: 'summaryTable4',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/summaryTable4')), 'summaryTable4')
    },
    {
      path: '/resourceGiftList',
      name: 'resourceGiftList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/resource/resourceGiftList')), 'resourceGiftList')
    },
    {
      path: '/resourceChangeLog',
      name: 'resourceChangeLog',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/resource/resourceChangeLog')), 'resourceChangeLog')
    },
    {
      path: '/eventAxis',
      name: 'eventAxis',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/eventAxis')), 'eventAxis')
    },
    {
      path: '/aMapSearch',
      name: 'aMapSearch',
      component: resolve => require.ensure([], () => resolve(require('@/components/aMapSearch')), 'aMapSearch')
    },
    {
      path: '/finaceClear',
      name: 'finaceClear',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/finance/finaceClear')), 'finaceClear')
    },
    {
      path: '/searchSettlementProjectList',
      name: 'searchSettlementProjectList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/finance/searchSettlementProjectList')), 'searchSettlementProjectList')
    },
    {
      path: '/settlementDetail',
      name: 'settlementDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/finance/settlementDetail')), 'settlementDetail')
    },
    {
      path: '/settlementAdd',
      name: 'settlementAdd',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/finance/settlementAdd')), 'settlementAdd')
    },
    {
      path: '/settlementPeople',
      name: 'settlementPeople',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/finance/settlementPeople')), 'settlementPeople')
    },
    {
      path: '/projectStall',
      name: 'projectStall',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/projectStall')), 'projectStall')
    },
    {
      path: '/auditFinanceList',
      name: 'auditFinanceList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/finance/audit/auditFinanceList')), 'auditFinanceList')
    },
    {
      path: '/auditFinanceDetail',
      name: 'auditFinanceDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/finance/audit/auditFinanceDetail')), 'auditFinanceDetail')
    },
    {
      path: '/paymentApproved',
      name: 'paymentApproved',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/finance/audit/paymentApproved')), 'paymentApproved')
    },
    {
      path: '/paymentApprovedDetail',
      name: 'paymentApprovedDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/finance/audit/paymentApprovedDetail')), 'paymentApprovedDetail')
    },
    {
      path: '/scoringRecord',
      name: 'scoringRecord',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/scoringRecord')), 'scoringRecord')
    },
    {
      path: '/punchClock',
      name: 'punchClock',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/checkWorkAttendance/punchClock')), 'editSignEx')
    },
    {
      path: '/myPunchClock',
      name: 'myPunchClock',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/checkWorkAttendance/myPunchClock')), 'editSignEx')
    },
    {
      path: '/projectPunchClockRecord',
      name: 'projectPunchClockRecord',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/checkWorkAttendance/projectPunchClockRecord')), 'editSignEx')
    },
    {
      path: '/punchClockStatistics',
      name: 'punchClockStatistics',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/checkWorkAttendance/punchClockStatistics')), 'editSignEx')
    },
    {
      path: '/inventoryRecord',
      name: 'inventoryRecord',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/inventory/inventoryRecord')), 'inventoryRecord')
    },
    {
      path: '/sharePersonList',
      name: 'sharePersonList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/resource/sharePersonList')), 'sharePersonList')
    },
    {
      path: '/uploadFilePage',
      name: 'uploadFilePage',
      component: resolve => require.ensure([], () => resolve(require('@/components/uploadFilePage')), 'uploadFilePage')
    },
    {
      path: '/fileTemp',
      name: 'fileTemp',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/fileTemp')), 'fileTemp')
    },
    {
      path: '/updateSummaryTable',
      name: 'updateSummaryTable',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/updateSummaryTable')), 'updateSummaryTable')
    },
    {
      path: '/resRelevanceResource',
      name: 'resRelevanceResource',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/resource/resRelevanceResource')), 'resRelevanceResource')
    },
    {
      path: '/ResourceRelationship',
      name: 'ResourceRelationship',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/resource/ResourceRelationship')), 'ResourceRelationship')
    },
    {
      path: '/developersList',
      name: 'developersList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/developers/developersList')), 'developersList')
    },
    {
      path: '/developers',
      name: 'developers',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/developers/developers')), 'developers')
    },
    {
      path: '/developersEdit',
      name: 'developersEdit',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/developers/developersEdit')), 'developersEdit')
    },
    {
      path: '/developersFile',
      name: 'developersFile',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/developers/developersFile')), 'developersFile')
    },
    {
      path: '/addDevelopersFile',
      name: 'addDevelopersFile',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/developers/addDevelopersFile')), 'addDevelopersFile')
    },
    {
      path: '/addDevelopersFollowUp',
      name: 'addDevelopersFollowUp',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/developers/addDevelopersFollowUp')), 'addDevelopersFollowUp')
    },
    {
      path: '/developersFollowUpRecords',
      name: 'developersFollowUpRecords',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/developers/developersFollowUpRecords')), 'developersFollowUpRecords')
    },
    {
      path: '/developersFollowUpView',
      name: 'developersFollowUpView',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/developers/developersFollowUpView')), 'developersFollowUpView')
    },
    {
      path: '/bondPending',
      name: 'bondPending',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/bond/bondPending')), 'bondPending')
    },

    {
      path: '/bondPendingProject',
      name: 'bondPendingProject',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/bond/bondPendingProject')), 'bondPendingProject')
    },
    {
      path: '/settlementInfoList',
      name: 'settlementInfoList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/finance/settlementInfoList')), 'settlementInfoList')
    },
    {
      path: '/calculate',
      name: 'calculate',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/calculate')), 'calculate')
    },
    {
      path: '/dataSheetToBeConfirmed',
      name: 'dataSheetToBeConfirmed',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/dataSheetToBeConfirmed')), 'dataSheetToBeConfirmed')
    },
    {
      path: '/tagAdd',
      name: 'tagAdd',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/resource/tagAdd')), 'tagAdd')
    },
    {
      path: '/recordUploadFilePage',
      name: 'recordUploadFilePage',
      component: resolve => require.ensure([], () => resolve(require('@/components/recordUploadFilePage')), 'recordUploadFilePage')
    },
    {
      path: '/recordingSelectList',
      name: 'recordingSelectList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/record/recordingSelectList')), 'recordingSelectList')
    },
    {
      path: '/recordingSelectListEx',
      name: 'recordingSelectListEx',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/record/recordingSelectListEx')), 'recordingSelectListEx')
    },
    {
      path: '/dailyApply',
      name: 'dailyApply',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/dailyApply')), 'dailyApply')
    },
    {
      path: '/flowPathView',
      name: 'flowPathView',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/flowPathView')), 'flowPathView')
    },
    {
      path: '/reimbursementProjectList',
      name: 'reimbursementProjectList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/reimbursementProjectList')), 'reimbursementProjectList')
    },
    {
      path: '/oaHome',
      name: 'oaHome',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/oaHome')), 'oaHome')
    },
    {
      path: '/paymentApplicationDetail',
      name: 'paymentApplicationDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/paymentApplicationDetail')), 'paymentApplicationDetail')
    },
    {
      path: '/paymentApplication',
      name: 'paymentApplication',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/paymentApplication')), 'paymentApplication')
    },
    {
      path: '/oaLaunch',
      name: 'oaLaunch',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/oaLaunch')), 'oaLaunch')
    },
    {
      path: '/oaReceive',
      name: 'oaReceive',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/oaReceive')), 'oaReceive')
    },
    {
      path: '/dailyApplyAuditOrView',
      name: 'dailyApplyAuditOrView',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/dailyApplyAuditOrView')), 'dailyApplyAuditOrView')
    },
    {
      path: '/oaPending',
      name: 'oaPending',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/oaPending')), 'oaPending')
    },
    {
      path: '/resourceDeveloperAndPropertyList',
      name: 'resourceDeveloperAndPropertyList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/resource/resourceDeveloperAndPropertyList')), 'resourceDeveloperAndPropertyList')
    },
    {
      path: '/oaCollectionAccount',
      name: 'oaCollectionAccount',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/oaCollectionAccount')), 'oaCollectionAccount')
    },
    {
      path: '/oaCollectionAccountDetail',
      name: 'oaCollectionAccountDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/oaCollectionAccountDetail')), 'oaCollectionAccountDetail')
    },
    {
      path: '/paymentList',
      name: 'paymentList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/payRecord/paymentList')), 'paymentList')
    },
    {
      path: '/paymentDetail',
      name: 'paymentDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/payRecord/paymentDetail')), 'paymentDetail')
    },
    {
      path: '/sendGiftMore',
      name: 'sendGiftMore',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/resource/sendGift/sendGiftMore')), 'sendGiftMore')
    },
    {
      path: '/expandPersonList',
      name: 'expandPersonList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/resource/sendGift/expandPersonList')), 'expandPersonList')
    },
    {
      path: '/oaMakeCopy',
      name: 'oaMakeCopy',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/oaMakeCopy')), 'oaMakeCopy')
    },
    {
      path: '/purchase',
      name: 'purchase',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/purchase')), 'purchase')
    },
    {
      path: '/betweenTwoPartiesList',
      name: 'betweenTwoPartiesList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/betweenTwoParties/betweenTwoPartiesList')), 'betweenTwoPartiesList')
    },
    {
      path: '/updateBetweenTwoParties',
      name: 'updateBetweenTwoParties',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/betweenTwoParties/updateBetweenTwoParties')), 'updateBetweenTwoParties')
    },
    {
      path: '/competitorList',
      name: 'competitorList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/competitor/competitorList')), 'competitorList')
    },
    {
      path: '/addCompetitor',
      name: 'addCompetitor',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/competitor/addCompetitor')), 'addCompetitor')
    },
    {
      path: '/addCompetitorSaleInfo',
      name: 'addCompetitorSaleInfo',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/competitor/addCompetitorSaleInfo')), 'addCompetitorSaleInfo')
    },
    {
      path: '/advancePaymentList',
      name: 'advancePaymentList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/advancePayment/advancePaymentList')), 'advancePaymentList')
    },
    {
      path: '/advancePayment',
      name: 'advancePayment',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/advancePayment/advancePayment')), 'advancePayment')
    },
    {
      path: '/paymentStatus',
      name: 'paymentStatus',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/advancePayment/paymentStatus')), 'paymentStatus')
    },
    {
      path: '/pressForMoneyList',
      name: 'pressForMoneyList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/pressForMoney/pressForMoneyList')), 'pressForMoneyList')
    },
    {
      path: '/pressForMoneyListByProject',
      name: 'pressForMoneyListByProject',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/pressForMoney/pressForMoneyListByProject')), 'pressForMoneyListByProject')
    },
    {
      path: '/addPressForMoney',
      name: 'addPressForMoney',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/pressForMoney/addPressForMoney')), 'addPressForMoney')
    },
    {
      path: '/pressForMoneyRecord',
      name: 'pressForMoneyRecord',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/pressForMoney/pressForMoneyRecord')), 'pressForMoneyRecord')
    },
    {
      path: '/pressForMoneyTimeRecords',
      name: 'pressForMoneyTimeRecords',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/pressForMoney/pressForMoneyTimeRecords')), 'pressForMoneyTimeRecords')
    },
    {
      path: '/pressForMoneyProjectList',
      name: 'pressForMoneyProjectList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/pressForMoney/pressForMoneyProjectList')), 'pressForMoneyProjectList')
    },
    {
      path: '/pressForMoneyDetail',
      name: 'pressForMoneyDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/pressForMoney/pressForMoneyDetail')), 'pressForMoneyDetail')
    },
    {
      path: '/CommerceClause',
      name: 'CommerceClause',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/pressForMoney/CommerceClause')), 'CommerceClause')
    },
    {
      path: '/pressForMoneyContractList',
      name: 'pressForMoneyContractList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/pressForMoney/pressForMoneyContractList')), 'pressForMoneyContractList')
    },
    {
      path: '/signPersontList',
      name: 'signPersontList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/signPersontList')), 'signPersontList')
    },
    {
      path: '/projectListforMarkPerson',
      name: 'projectListforMarkPerson',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/projectListforMarkPerson')), 'projectListforMarkPerson')
    },
    {
      path: '/statisticsDetailForMarkPerson',
      name: 'statisticsDetailForMarkPerson',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/statistics/statisticsDetailForMarkPerson')), 'statisticsDetailForMarkPerson')
    },
    {
      path: '/editProjectDetailForMarkPerson',
      name: 'editProjectDetailForMarkPerson',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/editProjectDetailForMarkPerson')), 'editProjectDetailForMarkPerson')
    },
    {
      path: '/projectDetailForMarkPerson',
      name: 'projectDetailForMarkPerson',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/projectDetailForMarkPerson')), 'projectDetailForMarkPerson')
    },
    {
      path: '/projectAppraisal',
      name: 'projectAppraisal',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/projectAppraisal')), 'projectAppraisal')
    },
    {
      path: '/SWOTList',
      name: 'SWOTList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/SWOTList')), 'SWOTList')
    },
    {
      path: '/SWOTAdd',
      name: 'SWOTAdd',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/SWOTAdd')), 'SWOTAdd')
    },
    {
      path: '/summaryTableForMarkPerson',
      name: 'summaryTableForMarkPerson',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/summaryTableForMarkPerson')), 'summaryTableForMarkPerson')
    },
    {
      path: '/PKProjectlist',
      name: 'PKProjectlist',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/PK/PKProjectlist')), 'PKProjectlist')
    },
    {
      path: '/PKPay',
      name: 'PKPay',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/PK/PKPay')), 'PKPay')
    },
    {
      path: '/myPKPay',
      name: 'myPKPay',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/PK/myPKPay')), 'myPKPay')
    },
    {
      path: '/PKResult',
      name: 'PKResult',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/PK/PKResult')), 'PKResult')
    },
    {
      path: '/contractList',
      name: 'contractList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/contract/contractList')), 'contractList')
    },
    {
      path: '/contractDetail',
      name: 'contractDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/contract/contractDetail')), 'contractDetail')
    },
    {
      path: '/replayList',
      name: 'replayList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/replay/replayList')), 'replayList')
    },
    {
      path: '/swotDetail',
      name: 'swotDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/replay/swotDetail')), 'swotDetail')
    },
    {
      path: '/projectReplayDetail',
      name: 'projectReplayDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/replay/projectReplayDetail')), 'projectReplayDetail')
    },
    {
      path: '/dailyRecordForReplay',
      name: 'dailyRecordForReplay',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/replay/dailyRecordForReplay')), 'dailyRecordForReplay')
    },
    {
      path: '/contractReplayDetail',
      name: 'contractReplayDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/replay/contractReplayDetail')), 'contractReplayDetail')
    },
    {
      path: '/addReplaySelectList',
      name: 'addReplaySelectList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/replay/addReplaySelectList')), 'addReplaySelectList')
    },
    {
      path: '/devScoreList',
      name: 'devScoreList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/developers/devScore/devScoreList')), 'devScoreList')
    },
    {
      path: '/mortgageDocument',
      name: 'mortgageDocument',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mortgageDocument/mortgageDocument')), 'mortgageDocument')
    },
    {
      path: '/mortgageDocumentDetail',
      name: 'mortgageDocumentDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mortgageDocument/mortgageDocumentDetail')), 'mortgageDocumentDetail')
    },
    {
      path: '/mortgageDocumentRecord',
      name: 'mortgageDocumentRecord',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mortgageDocument/mortgageDocumentRecord')), 'mortgageDocumentRecord')
    },
    {
      path: '/mortgagePicture',
      name: 'mortgagePicture',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mortgageDocument/mortgagePicture')), 'mortgagePicture')
    },
    {
      path: '/myScoreList',
      name: 'myScoreList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/myScoreList/myScoreList')), 'myScoreList')
    },
    {
      path: '/toDoList',
      name: 'toDoList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/toDoList/toDoList')), 'toDoList')
    },
    {
      path: '/toDoListDetail',
      name: 'toDoListDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/toDoList/toDoListDetail')), 'toDoListDetail')
    },
    {
      path: '/feedDetail',
      name: 'feedDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/toDoList/feedDetail')), 'feedDetail')
    },
    {
      path: '/projectShare',
      name: 'projectShare',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/toDoList/projectShare')), 'projectShare')
    },
    {
      path: '/toDoListRecords',
      name: 'toDoListRecords',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/toDoList/toDoListRecords')), 'toDoListRecords')
    },
    {
      path: '/contractFollowUp',
      name: 'contractFollowUp',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/toDoList/contractFollowUp')), 'contractFollowUp')
    },
    {
      path: '/contractFollowUpDetail',
      name: 'contractFollowUpDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/toDoList/contractFollowUpDetail')), 'contractFollowUpDetail')
    },
    {
      path: '/myStaffViolationList',
      name: 'myStaffViolationList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/myScoreList/myStaffViolationList')), 'myStaffViolationList')
    },
    {
      path: '/collectProjectDetail',
      name: 'collectProjectDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/managerCollect/collectProjectDetail')), 'collectProjectDetail')
    },
    {
      path: '/treadingPlateDeliver',
      name: 'treadingPlateDeliver',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/managerCollect/treadingPlateDeliver')), 'treadingPlateDeliver')
    },
    {
      path: '/collectProjectList',
      name: 'collectProjectList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/managerCollect/collectProjectList')), 'collectProjectList')
    },
    {
      path: '/simulationTable',
      name: 'simulationTable',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/simulationTable')), 'simulationTable')
    },
    {
      path: '/commercialTermsList',
      name: 'commercialTermsList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/commercialTerms/commercialTermsList')), 'commercialTermsList')
    },
    {
      path: '/commercialTerms',
      name: 'commercialTerms',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/commercialTerms/commercialTerms')), 'commercialTerms')
    },
    {
      path: '/businessClauseDetail',
      name: 'businessClauseDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessClause/businessClauseDetail')), 'businessClauseDetail')
    },

    {
      path: '/businessClauseList',
      name: 'businessClauseList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessClause/businessClauseList')), 'businessClauseList')
    },
    {
      path: '/simulationTableList',
      name: 'simulationTableList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/simulationTableList')), 'simulationTableList')
    },
    {
      path: '/simulationBusiness',
      name: 'simulationBusiness',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/simulationBusiness')), 'simulationBusiness')
    },
    {
      path: '/simulationShare',
      name: 'simulationShare',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/simulationShare')), 'simulationShare')
    },
    {
      path: '/simulationManagerList',
      name: 'simulationManagerList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/simulationManagerList')), 'simulationManagerList')
    },
    {
      path: '/signProcessDetail',
      name: 'signProcessDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/signProcess/signProcessDetail')), 'signProcessDetail')
    },
    {
      path: '/signProcessList',
      name: 'signProcessList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/signProcess/signProcessList')), 'signProcessList')
    },
    {
      path: '/projectListByQuestion',
      name: 'projectListByQuestion',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/surveyByQuestionnaire/projectList')), 'projectListByQuestion')
    },
    {
      path: '/proprietorListSBQ',
      name: 'proprietorListSBQ',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/surveyByQuestionnaire/proprietorListSBQ')), 'proprietorListSBQ')
    },
    {
      path: '/proprietorDetailSBQ',
      name: 'proprietorDetailSBQ',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/surveyByQuestionnaire/proprietorDetailSBQ')), 'proprietorDetailSBQ')
    },
    {
      path: '/proprietorReport',
      name: 'proprietorReport',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/surveyByQuestionnaire/proprietorReport')), 'proprietorReport')
    },
    {
      path: '/addCustomer',
      name: 'addCustomer',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/surveyByQuestionnaire/addCustomer')), 'addCustomer')
    },
    {
      path: '/callRecords',
      name: 'callRecords',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/surveyByQuestionnaire/callRecords')), 'callRecords')
    },
    {
      path: '/questionDetail',
      name: 'questionDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/surveyByQuestionnaire/questionDetail')), 'questionDetail')
    },
    {
      path: '/questionList',
      name: 'questionList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/surveyByQuestionnaire/questionList')), 'questionList')
    },
    {
      path: '/draftScoreList',
      name: 'draftScoreList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/score/draftScoreList')), 'draftScoreList')
    },
    {
      path: '/SWOHisTimeList',
      name: 'SWOHisTimeList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/SWOHisTimeList')), 'SWOHisTimeList')
    },
    {
      path: '/addSettlementInfoNew',
      name: 'addSettlementInfoNew',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/finance/addSettlementInfoNew')), 'addSettlementInfoNew')
    },
    {
      path: '/callCustmerRecords',
      name: 'callCustmerRecords',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/callCustmerRecords')), 'callCustmerRecords')
    },
    {
      path: '/callCustmerRecordsAdd',
      name: 'callCustmerRecordsAdd',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/callCustmerRecordsAdd')), 'callCustmerRecordsAdd')
    },
    {
      path: '/settlementDetailList',
      name: 'settlementDetailList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/finance/settlementDetailList')), 'settlementDetailList')
    },
    {
      path: '/tagSearch',
      name: 'tagSearch',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/resource/tagSearch')), 'tagSearch')
    },
    {
      path: '/monthlyReview',
      name: 'monthlyReview',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/statistics/monthlyReview')), 'monthlyReview')
    },
    {
      path: '/bankAccountBalance',
      name: 'bankAccountBalance',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/bankAccountBalance/bankAccountBalance')), 'bankAccountBalance')
    },
    {
      path: '/developerToBeSupplemented',
      name: 'developerToBeSupplemented',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/developerToBeSupplemented/developerToBeSupplemented')), 'developerToBeSupplemented')
    },
    {
      path: '/addSuppleDeveloper',
      name: 'addSuppleDeveloper',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/developerToBeSupplemented/addSuppleDeveloper')), 'addSuppleDeveloper')
    },
    {
      path: '/selectDBStaff',
      name: 'selectDBStaff',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/widget/selectDBStaff')), 'selectDBStaff')
    },
    {
      path: '/integralRule',
      name: 'integralRule',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/widget/integralRule')), 'selectDBStaff')
    },
    {
      path: '/worthMap',
      name: 'worthMap',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/worthMap')), 'worthMap')
    },
    {
      path: '/friendCircleMaterial',
      name: 'friendCircleMaterial',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/friendCircleMaterial/friendCircleMaterial')), 'friendCircleMaterial')
    },
    {
      path: '/uploadFriendCircleMaterial',
      name: 'uploadFriendCircleMaterial',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/friendCircleMaterial/uploadFriendCircleMaterial')), 'uploadFriendCircleMaterial')
    },
    {
      path: '/previewFullImagePage',
      name: 'previewFullImagePage',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/friendCircleMaterial/previewFullImagePage')), 'previewFullImagePage')
    },
    {
      path: '/uploadRecord',
      name: 'uploadRecord',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/friendCircleMaterial/uploadRecord')), 'uploadRecord')
    },
    {
      path: '/applyHelpPrice',
      name: 'applyHelpPrice',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/applyHelpPrice')), 'applyHelpPrice')
    },
    {
      path: '/applyHelpPriceList',
      name: 'applyHelpPriceList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/applyHelpPriceList')), 'applyHelpPriceList')
    },
    {
      path: '/assistProject',
      name: 'assistProject',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/assistProject')), 'assistProject')
    },
    {
      path: '/signProcess',
      name: 'signProcess',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/signProcessEx/signProcess')), 'signProcess')
    },
    {
      path: '/lostOrReportedLossList',
      name: 'lostOrReportedLossList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/lostOrReportedLoss/lostOrReportedLossList')), 'lostOrReportedLossList')
    },
    {
      path: '/lostOrReportedLossDetail',
      name: 'lostOrReportedLossDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/lostOrReportedLoss/lostOrReportedLossDetail')), 'lostOrReportedLossDetail')
    },
    {
      path: '/propertyToBeSupplemented',
      name: 'propertyToBeSupplemented',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/propertyToBeSupplemented/propertyToBeSupplemented')), 'propertyToBeSupplemented')
    },
    {
      path: '/addSuppleProperty',
      name: 'addSuppleProperty',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/propertyToBeSupplemented/addSuppleProperty')), 'addSuppleProperty')
    },
    {
      path: '/devGroupDetail',
      name: 'devGroupDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/developers/devGroup/devGroupDetail')), 'devGroupDetail')
    },
    {
      path: '/devGroupEdit',
      name: 'devGroupEdit',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/developers/devGroup/devGroupEdit')), 'devGroupEdit')
    },
    {
      path: '/devGroupList',
      name: 'devGroupList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/developers/devGroup/devGroupList')), 'devGroupList')
    },
    {
      path: '/devGroupRecord',
      name: 'devGroupRecord',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/developers/devGroup/devGroupRecord')), 'devGroupRecord')
    },
    {
      path: '/goodsConsumingList',
      name: 'goodsConsumingList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/goodsConsuming/goodsConsumingList')), 'goodsConsumingList')
    },
    {
      path: '/goodsConsumingAdd',
      name: 'goodsConsumingAdd',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/goodsConsuming/goodsConsumingAdd')), 'goodsConsumingAdd')
    },
    {
      path: '/purchaseGoods',
      name: 'purchaseGoods',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/goodsConsuming/purchaseGoods')), 'purchaseGoods')
    },
    {
      path: '/proCustomerServiceFeeList',
      name: 'proCustomerServiceFeeList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proCustomerServiceFee/proCustomerServiceFeeList')), 'proCustomerServiceFeeList')
    },
    {
      path: '/proCustomerServiceFeeDetail',
      name: 'proCustomerServiceFeeDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proCustomerServiceFee/proCustomerServiceFeeDetail')), 'proCustomerServiceFeeDetail')
    },
    {
      path: '/secondCustomerFeeDetail',
      name: 'secondCustomerFeeDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proCustomerServiceFee/secondCustomerFeeDetail')), 'secondCustomerFeeDetail')
    },
    {
      path: '/partyAReviewMeeting',
      name: 'partyAReviewMeeting',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/toDoList/partyAReviewMeeting')), 'partyAReviewMeeting')
    },
    {
      path: '/offlineClassList',
      name: 'offlineClassList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/offlineClass/offlineClassList')), 'offlineClassList')
    },
    {
      path: '/offlineClassDetail',
      name: 'offlineClassDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/offlineClass/offlineClassDetail')), 'offlineClassDetail')
    },
    {
      path: '/lecturerList',
      name: 'lecturerList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/lecturer/lecturerList')), 'lecturerList')
    },
    {
      path: '/lecturerDetail',
      name: 'lecturerDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/lecturer/lecturerDetail')), 'lecturerDetail')
    },
    {
      path: '/videoComplate',
      name: 'videoComplate',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/studyMap/videoComplate')), 'videoComplate')
    },
    {
      path: '/textbookDownloadList',
      name: 'textbookDownloadList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/studyMap/textbookDownloadList')), 'textbookDownloadList')
    },
    {
      path: '/studyTest',
      name: 'studyTest',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/studyMap/studyTest')), 'studyTest')
    },
    {
      path: '/practiseEveryDayList',
      name: 'practiseEveryDayList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/practiseEveryDay/practiseEveryDayList')), 'practiseEveryDayList')
    },
    {
      path: '/comonTest',
      name: 'comonTest',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/comonTest')), 'comonTest')
    },
    {
      path: '/passEveryWeekList',
      name: 'passEveryWeekList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/passEveryWeek/passEveryWeekList')), 'passEveryWeekList')
    },
    {
      path: '/passWeek',
      name: 'passWeek',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/passEveryWeek/passWeek')), 'passWeek')
    },
    {
      path: '/businessCollegeTaskList',
      name: 'businessCollegeTaskList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/businessCollegeTask/businessCollegeTaskList')), 'businessCollegeTaskList')
    },
    {
      path: '/studyForumList',
      name: 'studyForumList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/studyForum/studyForumList')), 'studyForumList')
    },
    {
      path: '/studyForumAddQuestion',
      name: 'studyForumAddQuestion',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/studyForum/studyForumAddQuestion')), 'studyForumAddQuestion')
    },
    {
      path: '/studyForumAddQuestionDetail',
      name: 'studyForumAddQuestionDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/studyForum/studyForumAddQuestionDetail')), 'studyForumAddQuestionDetail')
    },
    {
      path: '/studyForumAnswerQuestion',
      name: 'studyForumAnswerQuestion',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/studyForum/studyForumAnswerQuestion')), 'studyForumAnswerQuestion')
    },
    {
      path: '/newComerMentoringList',
      name: 'newComerMentoringList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/newComerMentoring/newComerMentoringList')), 'newComerMentoringList')
    },
    {
      path: '/addComerMentoring',
      name: 'addComerMentoring',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/newComerMentoring/addComerMentoring')), 'addComerMentoring')
    },
    {
      path: '/businessCollegeList',
      name: 'businessCollegeList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/businessCollegeList')), 'businessCollegeList')
    },
    {
      path: '/businessCollegeContent',
      name: 'businessCollegeContent',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/businessCollegeContent')), 'businessCollegeContent')
    },
    {
      path: '/suppleDeveloperFollowUp',
      name: 'suppleDeveloperFollowUp',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/developerToBeSupplemented/suppleDeveloperFollowUp')), 'suppleDeveloperFollowUp')
    },
    {
      path: '/supplePropertyFollowUp',
      name: 'supplePropertyFollowUp',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/propertyToBeSupplemented/supplePropertyFollowUp')), 'supplePropertyFollowUp')
    },
    {
      path: '/draftContractList',
      name: 'draftContractList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/draftContract/draftContractList')), 'draftContractList')
    },
    {
      path: '/draftContract',
      name: 'draftContract',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/draftContract/draftContract')), 'draftContract')
    },
    {
      path: '/draftApprovalRecord',
      name: 'draftApprovalRecord',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/draftContract/draftApprovalRecord')), 'draftApprovalRecord')
    },
    {
      path: '/applyReplayMeeting',
      name: 'applyReplayMeeting',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/toDoList/applyReplayMeeting')), 'applyReplayMeeting')
    },
    {
      path: '/importantToDoList',
      name: 'importantToDoList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/toDoList/importantToDoList')), 'importantToDoList')
    },
    {
      path: '/dataModel',
      name: 'dataModel',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/dataModel/dataModel')), 'dataModel')
    },
    {
      path: '/dataModelTable',
      name: 'dataModelTable',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/dataModel/dataModelTable')), 'dataModelTable')
    },
    {
      path: '/dataModelSub',
      name: 'dataModelSub',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/dataModel/dataModelSub')), 'dataModelSub')
    },
    {
      path: '/dataModelSubDetail',
      name: 'dataModelSubDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/dataModel/dataModelSubDetail')), 'dataModelSubDetail')
    },
    {
      path: '/dataModelUpdateRecord',
      name: 'dataModelUpdateRecord',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/dataModel/dataModelUpdateRecord')), 'dataModelUpdateRecord')
    },
    {
      path: '/aroundProjectList',
      name: 'aroundProjectList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/aroundProjectList')), 'aroundProjectList')
    },
    {
      path: '/scanStreetMap',
      name: 'scanStreetMap',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/scanStreetMap')), 'scanStreetMap')
    },
    {
      path: '/addScanStreetProject',
      name: 'addScanStreetProject',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/addScanStreetProject')), 'addScanStreetProject')
    },
    {
      path: '/expectSignProjectList',
      name: 'expectSignProjectList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/expectSignProject/expectSignProjectList')), 'expectSignProjectList')
    },

    {
      path: '/addExpectSignProject',
      name: 'addExpectSignProject',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/expectSignProject/addExpectSignProject')), 'addExpectSignProject')
    },
    {
      path: '/reserveProjectsList',
      name: 'reserveProjectsList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reserveProjects/reserveProjectsList')), 'reserveProjectsList')
    },
    {
      path: '/addReserveProject',
      name: 'addReserveProject',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reserveProjects/addReserveProject')), 'addReserveProject')
    },
    {
      path: '/updateRecordPage',
      name: 'updateRecordPage',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reserveProjects/updateRecordPage')), 'updateRecordPage')
    },
    {
      path: '/businessTermsList',
      name: 'businessTermsList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessTerms/businessTermsList')), 'businessTermsList')
    },
    {
      path: '/addBusinessTerms',
      name: 'addBusinessTerms',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessTerms/addBusinessTerms')), 'addBusinessTerms')
    },
    {
      path: '/businessTermsDetail',
      name: 'businessTermsDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessTerms/businessTermsDetail')), 'businessTermsDetail')
    },
    {
      path: '/selectSignCompany',
      name: 'selectSignCompany',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessTerms/selectSignCompany')), 'selectSignCompany')
    },
    {
      path: '/dataModelCommonEdit',
      name: 'dataModelCommonEdit',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/dataModel/dataModelCommonEdit')), 'dataModelCommonEdit')
    },
    {
      path: '/resourceTransmitList',
      name: 'resourceTransmitList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/resourceTransmit/resourceTransmitList')), 'resourceTransmitList')
    },
    {
      path: '/resourceTransmitDetail',
      name: 'resourceTransmitDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/resourceTransmit/resourceTransmitDetail')), 'resourceTransmitDetail')
    },
    {
      path: '/resourceTransmitRecord',
      name: 'resourceTransmitRecord',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/resourceTransmit/resourceTransmitRecord')), 'resourceTransmitRecord')
    },
    {
      path: '/addResourceTransmit',
      name: 'addResourceTransmit',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/resourceTransmit/addResourceTransmit')), 'addResourceTransmit')
    },
    {
      path: '/withdrawalMeetingList',
      name: 'withdrawalMeetingList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/withdrawalMeeting/withdrawalMeetingList')), 'withdrawalMeetingList')
    },
    {
      path: '/withdrawalMeetingDetail',
      name: 'withdrawalMeetingDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/withdrawalMeeting/withdrawalMeetingDetail')), 'withdrawalMeetingDetail')
    },
    {
      path: '/projectDetailEx',
      name: 'projectDetailEx',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/projectDetailEx')), 'projectDetailEx')
    },
    {
      path: '/editProjectDetailEx',
      name: 'editProjectDetailEx',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/editProjectDetailEx')), 'editProjectDetailEx')
    },
    {
      path: '/competitorListNew',
      name: 'competitorListNew',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/competitorNew/competitorListNew')), 'competitorListNew')
    },
    {
      path: '/relationFileList',
      name: 'relationFileList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/relationFileList')), 'relationFileList')
    },
    {
      path: '/competitorFollowUpRecords',
      name: 'competitorFollowUpRecords',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/competitorNew/competitorFollowUpRecords')), 'competitorFollowUpRecords')
    },
    {
      path: '/competitorProjectRelation',
      name: 'competitorProjectRelation',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/competitorNew/competitorProjectRelation')), 'competitorProjectRelation')
    },
    {
      path: '/competitorAdd',
      name: 'competitorAdd',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/competitorNew/competitorAdd')), 'competitorAdd')
    },
    {
      path: '/competitorAddRelation',
      name: 'competitorAddRelation',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/competitorNew/competitorAddRelation')), 'competitorAddRelation')
    },
    {
      path: '/managerReplayList',
      name: 'managerReplayList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/managerReplay/managerReplayList')), 'managerReplayList')
    },
    {
      path: '/meetingManageList',
      name: 'meetingManageList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/meetingManage/meetingManageList')), 'meetingManageList')
    },

    {
      path: '/managerReplayViewTab',
      name: 'managerReplayViewTab',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/managerReplay/managerReplayViewTab')), 'managerReplayViewTab')
    },
    {
      path: '/summaryTableChangeLog',
      name: 'summaryTableChangeLog',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/summaryTableChangeLog')), 'summaryTableChangeLog')
    },
    {
      path: '/promiseFilleList',
      name: 'promiseFilleList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/promiseFile/promiseFilleList')), 'promiseFilleList')
    },
    {
      path: '/promiseFilleEdit',
      name: 'promiseFilleEdit',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/promiseFile/promiseFilleEdit')), 'promiseFilleEdit')
    },
    {
      path: '/offlineClassRate',
      name: 'offlineClassRate',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/offlineClass/offlineClassRate')), 'offlineClassRate')
    },
    {
      path: '/medalPage',
      name: 'medalPage',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/medal/medalPage')), 'medalPage')
    },
    {
      path: '/medalStatistic',
      name: 'medalStatistic',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/medal/medalStatistic')), 'medalStatistic')
    },
    {
      path: '/infoShareList',
      name: 'infoShareList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/infoShare/infoShareList')), 'infoShareList')
    },
    {
      path: '/dataModelHistoryList',
      name: 'dataModelHistoryList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/dataModel/dataModelHistoryList')), 'dataModelHistoryList')
    },
    {
      path: '/cooperationInfoBoard',
      name: 'cooperationInfoBoard',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/cooperationInfo/cooperationInfoBoard')), 'cooperationInfoBoard')
    },
    {
      path: '/cooperationInfoDevoloperList',
      name: 'cooperationInfoDevoloperList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/cooperationInfo/cooperationInfoDevoloperList')), 'cooperationInfoDevoloperList')
    },
    {
      path: '/cooperationInfoDevoloperDetail',
      name: 'cooperationInfoDevoloperDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/cooperationInfo/cooperationInfoDevoloperDetail')), 'cooperationInfoDevoloperDetail')
    },
    {
      path: '/cooperationInfoProjectList',
      name: 'cooperationInfoProjectList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/cooperationInfo/cooperationInfoProjectList')), 'cooperationInfoProjectList')
    },
    {
      path: '/cooperationProjectInfo',
      name: 'cooperationProjectInfo',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/cooperationInfo/cooperationProjectInfo')), 'cooperationProjectInfo')
    },
    {
      path: '/resProjectRelation',
      name: 'resProjectRelation',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/resource/follow/resProjectRelation')), 'resProjectRelation')
    },
    {
      path: '/projectFollowUpSummary',
      name: 'projectFollowUpSummary',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/follow/projectFollowUpSummary')), 'projectFollowUpSummary')
    },
    {
      path: '/senseOfWorthDetail',
      name: 'senseOfWorthDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/senseOfWorthDetail')), 'senseOfWorthDetail')
    },
    {
      path: '/meetingManageList',
      name: 'meetingManageList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/meetingManage/meetingManageList')), 'meetingManageList')
    },
    {
      path: '/meetingDetail',
      name: 'meetingDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/meetingManage/meetingDetail')), 'meetingDetail')
    },
    {
      path: '/decisionChain',
      name: 'decisionChain',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/resource/decisionChain')), 'decisionChain')
    },
    {
      path: '/myRecordingList',
      name: 'myRecordingList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/record/myRecordingList')), 'myRecordingList')
    },
    {
      path: '/callCenterList',
      name: 'callCenterList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/callCenter/callCenterList')), 'callCenterList')
    },
    {
      path: '/startApply',
      name: 'startApply',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/callCenter/startApply')), 'startApply')
    },
    {
      path: '/otherDeverloperList',
      name: 'otherDeverloperList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/callCenter/otherDeverloperList')), 'otherDeverloperList')
    },
    {
      path: '/inquiryDetails',
      name: 'inquiryDetails',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/callCenter/inquiryDetails')), 'inquiryDetails')
    },
    {
      path: '/callDetails',
      name: 'callDetails',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/callCenter/callDetails')), 'callDetails')
    },
    {
      path: '/callRecordList',
      name: 'callRecordList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/callCenter/callRecordList')), 'callRecordList')
    },
    {
      path: '/regionalPoliciesList',
      name: 'regionalPoliciesList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/regionalPolicies/regionalPoliciesList')), 'regionalPoliciesList')
    },
    {
      path: '/addRegionalPolicies',
      name: 'addRegionalPolicies',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/regionalPolicies/addRegionalPolicies')), 'addRegionalPolicies')
    },
    {
      path: '/addPoliciesData',
      name: 'addPoliciesData',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/regionalPolicies/addPoliciesData')), 'addPoliciesData')
    },
    {
      path: '/workOrderList',
      name: 'workOrderList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/workOrder/workOrderList')), 'workOrderList')
    },
    {
      path: '/startWorkOrder',
      name: 'startWorkOrder',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/workOrder/startWorkOrder')), 'startWorkOrder')
    },
    {
      path: '/draftContract1',
      name: 'draftContract1',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/draftContract/draftContract1')), 'draftContract1')
    },
    {
      path: '/draftContractDetail',
      name: 'draftContractDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/draftContract/draftContractDetail')), 'draftContractDetail')
    },
    {
      path: '/developersContactInformation',
      name: 'developersContactInformation',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/developersContactInformation/developersContactInformation')), 'developersContactInformation')
    },
    {
      path: '/developersContactInformationDetail',
      name: 'developersContactInformationDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/developersContactInformation/developersContactInformationDetail')), 'developersContactInformationDetail')
    },
    {
      path: '/propertyContactInformation',
      name: 'propertyContactInformation',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/propertyContactInformation/propertyContactInformation')), 'propertyContactInformation')
    },
    {
      path: '/propertyContactInformationDetail',
      name: 'propertyContactInformationDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/propertyContactInformation/propertyContactInformationDetail')), 'propertyContactInformationDetail')
    },
    {
      path: '/allSelectStaff',
      name: 'allSelectStaff',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/borrow/allSelectStaff')), 'allSelectStaff')
    },
    {
      path: '/tagDesc',
      name: 'tagDesc',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/resource/tagDesc')), 'tagDesc')
    },
    {
      path: '/signProcessEx1',
      name: 'signProcessEx1',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/signProcessEx1/signProcessEx1')), 'signProcessEx1')
    },
    {
      path: '/signProcessEx1Child',
      name: 'signProcessEx1Child',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/signProcessEx1/signProcessEx1Child')), 'signProcessEx1Child')
    },
    {
      path: '/dailyReport',
      name: 'dailyReport',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/dailyReport/dailyReport')), 'dailyReport')
    },
    {
      path: '/dailyReportList',
      name: 'dailyReportList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/dailyReport/dailyReportList')), 'dailyReportList')
    },
    {
      path: '/resourceShare',
      name: 'resourceShare',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/toDoList/resourceShare')), 'resourceShare')
    },
    {
      path: '/summaryTable5',
      name: 'summaryTable5',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/SummaryTable/summaryTable5')), 'summaryTable5')
    },
    {
      path: '/updateSummaryTable2',
      name: 'updateSummaryTable2',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/SummaryTable/updateSummaryTable2')), 'updateSummaryTable2')
    },
    {
      path: '/projectStall2',
      name: 'projectStall2',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/SummaryTable/projectStall2')), 'projectStall2')
    },
    {
      path: '/projectStallParkType',
      name: 'projectStallParkType',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/SummaryTable/projectStallParkType')), 'projectStallParkType')
    },
    {
      path: '/setFiveYearSaleTeam',
      name: 'setFiveYearSaleTeam',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/SummaryTable/setFiveYearSaleTeam')), 'setFiveYearSaleTeam')
    },
    {
      path: '/projectSiteVisit',
      name: 'projectSiteVisit',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/SummaryTable/projectSiteVisit')), 'projectSiteVisit')
    },
    {
      path: '/addProjectSiteVisit',
      name: 'addProjectSiteVisit',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/SummaryTable/addProjectSiteVisit')), 'addProjectSiteVisit')
    },
    {
      path: '/resGroupEdit',
      name: 'resGroupEdit',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/resource/follow/resGroupEdit')), 'resGroupEdit')
    },
    {
      path: '/swotTable',
      name: 'swotTable',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/SummaryTable/swotTable')), 'swotTable')
    },
    {
      path: '/sourceOfResources',
      name: 'sourceOfResources',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/resource/sourceOfResources')), 'sourceOfResources')
    },
    {
      path: '/publicAreaResourceList',
      name: 'publicAreaResourceList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/resource/publicAreaResource/publicAreaResourceList')), 'publicAreaResourceList')
    },
    {
      path: '/publicAreaResourceDetail',
      name: 'publicAreaResourceDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/resource/publicAreaResource/publicAreaResourceDetail')), 'publicAreaResourceDetail')
    },
    {
      path: '/settlementUpdateRecord',
      name: 'settlementUpdateRecord',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/finance/settlementUpdateRecord')), 'settlementUpdateRecord')
    },
     {
      path: '/selectExpandOneForEachCompany',
      name: 'selectExpandOneForEachCompany',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/finance/selectExpandOneForEachCompany')), 'selectExpandOneForEachCompany')
    },
    {
      path: '/settlementMonthDetail',
      name: 'settlementMonthDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/finance/settlementMonthDetail')), 'settlementMonthDetail')
    },
    {
      path: '/settlementParkInfo',
      name: 'settlementParkInfo',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/finance/settlementParkInfo')), 'settlementParkInfo')
    },
    {
      path: '/statisticsDetailVersion2',
      name: 'statisticsDetailVersion2',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/statistics/statisticsDetailVersion2')), 'statisticsDetailVersion2')
    },
    {
      path: '/scheduleListList',
      name: 'scheduleListList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/schedule/scheduleListList')), 'scheduleListList')
    },
    {
      path: '/scheduleDetail',
      name: 'scheduleDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/schedule/scheduleDetail')), 'scheduleDetail')
    },
    {
      path: '/aiProjectInfo',
      name: 'aiProjectInfo',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/SummaryTable/aiProjectInfo')), 'aiProjectInfo')
    },
    {
      path: '/meetingDecision',
      name: 'meetingDecision',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/meetingDecision')), 'meetingDecision')
    },
    {
      path: '/customersList',
      name: 'customersList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/customer/customersList')), 'customersList')
    },
    {
      path: '/customersEdit',
      name: 'customersEdit',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/customer/customersEdit')), 'customersEdit')
    },
    {
      path: '/customersDetail',
      name: 'customersDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/customer/customersDetail')), 'customersDetail')
    },
    {
      path: '/customersRelationRecord',
      name: 'customersRelationRecord',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/customer/customersRelationRecord')), 'customersRelationRecord')
    },
    {
      path: '/customersHistoryRecord',
      name: 'customersHistoryRecord',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/customer/customersHistoryRecord')), 'customersHistoryRecord')
    },
    {
      path: '/customersSituationEdit',
      name: 'customersSituationEdit',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/customer/customersSituationEdit')), 'customersSituationEdit')
    },
    {
      path: '/customersRelationList',
      name: 'customersRelationList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/customer/customersRelationList')), 'customersRelationList')
    },
    {
      path: '/customerRelationSynchronous',
      name: 'customerRelationSynchronous',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/customer/customerRelationSynchronous')), 'customerRelationSynchronous')
    },
    {
      path: '/dataModelSubDetailEx',
      name: 'dataModelSubDetailEx',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/dataModel/dataModelSubDetailEx')), 'dataModelSubDetailEx')
    },
     {
      path: '/customersMergeSure',
      name: 'customersMergeSure',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/customer/customersMergeSure')), 'customersMergeSure')
    },
    {
      path: '/generalSecondLevelBoard',
      name: 'generalSecondLevelBoard',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/generalSecondLevelBoard')), 'generalSecondLevelBoard')
    },
    {
      path: '/businessCardDetail',
      name: 'businessCardDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCard/businessCardDetail')), 'businessCardDetail')
    },
    {
      path: '/mergeFollowRecords',
      name: 'mergeFollowRecords',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/customer/mergeFollowRecords')), 'mergeFollowRecords')
    },
    {
      path: '/businessCardDynamicList',
      name: 'businessCardDynamicList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCard/businessCardDynamicList')), 'businessCardDynamicList')
    },
    {
      path: '/businessCardDynamicEdit',
      name: 'businessCardDynamicEdit',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCard/businessCardDynamicEdit')), 'businessCardDynamicEdit')
    },
    {
      path: '/customersCompareSub',
      name: 'customersCompareSub',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/customer/customersCompareSub')), 'customersCompareSub')
    },
    {
      path: '/developerReceptionList',
      name: 'developerReceptionList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/developerReception/developerReceptionList')), 'developerReceptionList')
    },
    {
      path: '/developerReceptionEdit',
      name: 'developerReceptionEdit',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/developerReception/developerReceptionEdit')), 'developerReceptionEdit')
    },
    {
      path: '/shareDataTableSure',
      name: 'shareDataTableSure',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/SummaryTable/shareDataTableSure')), 'shareDataTableSure')
    },
    {
      path: '/workPlanListList',
      name: 'workPlanListList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/workPlan/workPlanListList')), 'workPlanListList')
    },
    {
      path: '/workPlanDetail',
      name: 'workPlanDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/workPlan/workPlanDetail')), 'workPlanDetail')
    },
    {
      path: '/statisticsFaceResource',
      name: 'statisticsFaceResource',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/statistics/statisticsFaceResource')), 'statisticsFaceResource')
    },
    {
      path: '/statisticsCallResource',
      name: 'statisticsCallResource',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/statistics/statisticsCallResource')), 'statisticsCallResource')
    },
    {
      path: '/workPlanCalendar',
      name: 'workPlanCalendar',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/workPlan/workPlanCalendar')), 'workPlanCalendar')
    },
    {
      path: '/helpSmart',
      name: 'helpSmart',
      component: resolve => require.ensure([], () => resolve(require('@/components/helpSmart')), 'helpSmart')
    },
    {
      path: '/addFollowProjectOrResource',
      name: 'addFollowProjectOrResource',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/workPlan/addFollowProjectOrResource')), 'addFollowProjectOrResource')
    },
    {
      path: '/workPlanEditRecord',
      name: 'workPlanEditRecord',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/workPlan/workPlanEditRecord')), 'workPlanEditRecord')
    },
    {
      path: '/resourceRecommendList',
      name: 'resourceRecommendList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/resource/resourceRecommendList')), 'resourceRecommendList')
    },
    {
      path: '/resourceRecommendEdit',
      name: 'resourceRecommendEdit',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/resource/resourceRecommendEdit')), 'resourceRecommendEdit')
    },
    {
      path: '/resourceRecommendDetail',
      name: 'resourceRecommendDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/resource/resourceRecommendDetail')), 'resourceRecommendDetail')
    },
    {
      path: '/resourceVerifyList',
      name: 'resourceVerifyList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/resource/resourceVerifyList')), 'resourceVerifyList')
    },
    {
      path: '/noWorkPlanList',
      name: 'noWorkPlanList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/workPlan/noWorkPlanList')), 'noWorkPlanList')
    },
    {
      path: '/noWorkPlanEdit',
      name: 'noWorkPlanEdit',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/workPlan/noWorkPlanEdit')), 'noWorkPlanEdit')
    },
    {
      path: '/settlementContract',
      name: 'settlementContract',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/finance/settlementContract')), 'settlementContract')
    },
    {
      path: '/monthTargetList',
      name: 'monthTargetList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/monthTarget/monthTargetList')), 'monthTargetList')
    },
    {
      path: '/selectRelationCustomerForBusiness',
      name: 'selectRelationCustomerForBusiness',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/resource/follow/selectRelationCustomerForBusiness')), 'selectRelationCustomerForBusiness')
    },
    {
      path: '/businessEdit',
      name: 'businessEdit',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/resource/follow/businessEdit')), 'businessEdit')
    },
    {
      path: '/customersRelationProjectList',
      name: 'customersRelationProjectList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/customer/customersRelationProjectList')), 'customersRelationProjectList')
    },
    {
      path: '/interviewRecordingList',
      name: 'interviewRecordingList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/interviewRecording/interviewRecordingList')), 'interviewRecordingList')
    },
     {
      path: '/recordingDevice',
      name: 'recordingDevice',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/interviewRecording/recordingDevice')), 'recordingDevice')
    },
    {
      path: '/interviewRecordingAgent',
      name: 'interviewRecordingAgent',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/interviewRecording/interviewRecordingAgent')), 'interviewRecordingAgent')
    },
    {
      path: '/interviewRecordingAudio',
      name: 'interviewRecordingAudio',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/interviewRecording/interviewRecordingAudio')), 'interviewRecordingAudio')
    },
    {
      path: '/relationThirdPartyListList',
      name: 'relationThirdPartyListList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/resource/relationThirdPartyListList')), 'relationThirdPartyListList')
    },
    {
      path: '/interviewRecordingAgentUpdate',
      name: 'interviewRecordingAgentUpdate',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/interviewRecording/interviewRecordingAgentUpdate')), 'interviewRecordingAgentUpdate')
    },
    {
      path: '/customerGroupFourBusinessList',
      name: 'customerGroupFourBusinessList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/customerGroupFourBusiness/customerGroupFourBusinessList')), 'customerGroupFourBusinessList')
    },
    {
      path: '/customerGroupFourBusiness',
      name: 'customerGroupFourBusiness',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/customerGroupFourBusiness/customerGroupFourBusiness')), 'customerGroupFourBusiness')
    },
    {
      path: '/customerGroupFourBusinessScoreList',
      name: 'customerGroupFourBusinessScoreList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/customerGroupFourBusiness/customerGroupFourBusinessScoreList')), 'customerGroupFourBusinessScoreList')
    },
    {
      path: '/agentList',
      name: 'agentList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/msg/agentList')), 'agentList')
    },
    {
      path: '/customerGroupFourBusinessAuditList',
      name: 'customerGroupFourBusinessAuditList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/customerGroupFourBusiness/customerGroupFourBusinessAuditList')), 'customerGroupFourBusinessAuditList')
    },
    {
      path: '/customerGroupFourBusinessAuditDetail',
      name: 'customerGroupFourBusinessAuditDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/customerGroupFourBusiness/customerGroupFourBusinessAuditDetail')), 'customerGroupFourBusinessAuditDetail')
    },
    {
      path: '/agentIframe',
      name: 'agentIframe',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/msg/agentIframe')), 'agentIframe')
    },
    {
      path: '/faceTalkModelHTQY',
      name: 'faceTalkModelHTQY',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/interviewRecording/components/faceTalkModelHTQY')), 'faceTalkModelHTQY')
    },
     {
      path: '/validateBusinessResultPage',
      name: 'validateBusinessResultPage',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/interviewRecording/validateBusinessResultPage')), 'validateBusinessResultPage')
    },



  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js